import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <AppSection />
        <RankingSection />
        <IndexSection />
        <FeaturesSection />
        <CommentsSection />
        <UpdatesSection />
        <CarouselSection />
        <TopicsSection />
        <CardsSection />
        <ContactSection />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}